export default {
  REGISTER: {
    REGISTER_PHONE_REGISTER: '/api/ucenter/front/member/third/phoneRegister',
    REGISTER_SEND_MEMBER: '/api/ucenter/member/mob/sendSmsForMember',
    // 图形验证码
    CAPTCHA: "/api/base/front/img/generate-code"
  }
}
